import React from "react";

/**
 * @type 'custom' | 'error' | 'info' | 'success' | 'warning'
 */
export default React.memo(({id, type, iconClass, message, children}) => {

    if (iconClass) {
        return <div id={id} className={"dx-toast-content dx-toast-" + type}>
            <i className={iconClass} style={{marginRight:10}}/>
            <p>{message}</p>
        </div>
    }

    return <div id={id} className={"dx-toast-content dx-toast-" + type}>
        {children}
    </div>
});
